import { Field } from 'formik';
import { Textarea, FormControl, Grid, GridItem, Heading, Box, useStyleConfig } from '@chakra-ui/react';
import ElementInstructions from '../../formElements/components/ElementInstructions';
import ElementHeading from '../../formElements/components/ElementHeading';
import ElementErrorMessage from '../../formElements/components/ElementErrorMessage';
import { transformRSInput } from '../../formControllers/Transformation/Utils';
import InputWrapper from '../../formElements/components/InputWrapper';
import { clearResume } from '../../formElements/utils';
import ReactPlayer from 'react-player';
import { getUsefulVars } from '../../handlers/helpers';

const RSTextareaVideo = ({ fieldName, qObj, jobSeekerData, props }) => {
  const variant = 'wrapper';
  const elementStyles = useStyleConfig('Element', { variant });

  fieldName ="jobSeekerData[0][\""+qObj.qid+"\"]";

  return (
    <Field name={fieldName}>
      {({ field, form }) => {
        if(jobSeekerData[0] !== undefined && jobSeekerData[0] !== null) {
          field.value =jobSeekerData[0][qObj.qid] === undefined ? '' : jobSeekerData[0][qObj.qid];

        }
         return (
          <FormControl sx={{ ...elementStyles }} isInvalid={form.errors[qObj.id] && form.touched[qObj.id]}>
            <Box className="rsTextAreaVideoWrapper">
              <Box className="heroImageBox heroImageLeft">
                <ReactPlayer
                  url={qObj.video}
                  controls={true}
                  className="heroImageImg"
                  onError={(e) => console.error('Video playback error:', e)}
                  fallback={<Box>Video unavailable</Box>}
                />
              </Box>
              <Box area="form" className="formWrapper">
                <Heading className='qHeading'>{qObj.question}</Heading>
                <Box whiteSpace='pre-wrap'>{qObj.instructions}</Box>
                <InputWrapper>
                  <Textarea
                    placeholder={qObj.placeholder}
                    {...field}
                    onChange={e =>
                      transformRSInput(e, jobSeekerData, 0, qObj, props)
                    }
                  />
                </InputWrapper>
              </Box>
              <ElementErrorMessage form={form} index={qObj.index} qid={qObj.qid} />
            </Box>
          </FormControl>
        );
      }}
    </Field>
  );
};

export default RSTextareaVideo;
